import * as actionTypes from '../actions/actionTypes';
import _ from 'lodash';
import {ObjectId} from 'bson'
import * as api from 'api'
import store from '../store'
import { socketUpdates } from 'utils';

import { Client, ClientWorkflow } from 'schema'

////////////////
// 1. CLIENTS //
////////////////
export const getClients = (filters) => {
    return dispatch => {
        api.getClients(filters)
        .then(res => {
            const clients = res.data['clients']
            let data = {}
            clients.map(value => {
                const client = new Client(value)
                client['id'] = value['_id']
                data[value['_id']] = client
            })
            console.log('[getClients] completed', data)
            dispatch({ type: actionTypes.UPDATE_CLIENTS, clients: data })
        })
        .catch(err => {
            console.log('[getClients] failed', err)
        })
    }
}

export const createClient = (client, data, callback) => {
    let updatedData = {...data}
    return dispatch => {
        dispatch({ type: actionTypes.UPDATE_CLIENTS, clients: updatedData })
    }
}

export const deleteClient = (client, clients, workflows, callback) => {
    let updatedClients = {...clients}
    let updatedWorkflows = {...workflows}

    // Remove client
    const clientId = client['id']
    delete updatedClients[clientId]

    // Remove related workflows
    const workflowIds = client['workflowIds']
    workflowIds.map(workflowId => delete updatedWorkflows[workflowId])

    return dispatch => {
        dispatch({ type: actionTypes.UPDATE_CLIENTS, clients: updatedClients })
        dispatch({ type: actionTypes.UPDATE_WORKFLOWS, workflows: updatedWorkflows })

        api.deleteClient(clientId, {client: client})
        .then(res => {
            console.log('[deleteClient] completed', res)
            
        })
        .catch(err => {
            console.log('[deleteClient] failed', err)
        })
        
    }
}

export const updateClients = (clients) => {
    console.log('[updateClients]', clients)
    return { type: actionTypes.UPDATE_CLIENTS, clients: clients }
}

//////////////////
// 2. WORKFLOWS //
//////////////////
export const updateWorkflows = (workflows) => {
    console.log('[updateWorkflows]', workflows)
    return { type: actionTypes.UPDATE_WORKFLOWS, workflows }
}

export const getWorkflows = (filters) => {
    const debug = false;
    return dispatch => {
        api.getWorkflows(filters)
        .then(res => {
            const workflows = res.data['workflows']
            let data = {}
            workflows.map(value => {
                const workflow = new ClientWorkflow(value)
                workflow['workflowId'] = value['_id']
                data[value['_id']] = workflow
            })
            debug && console.log('[getWorkflows] completed', data)
            dispatch({ type: actionTypes.UPDATE_WORKFLOWS, workflows: data })
        })
        .catch(err => {
            debug && console.log('[getWorkflows] failed', err)
        })
    }
}

export const createWorkflow = (workflow, data, callback) => {
    let updatedData = {...data}
    const workflowID = new ObjectId().toString();
    workflow['_id'] = workflowID;
    workflow['workflowId'] = workflowID
    updatedData[workflowID] = new ClientWorkflow(workflow)

    return dispatch => {
        dispatch({ type: actionTypes.UPDATE_WORKFLOWS, workflows: updatedData })
        api.createWorkflow(workflow)
        .then(res => {
            console.log('[integrations.js] createWorkflow', { workflow: workflow, workflows: updatedData }, res.data)
        })
        .catch(err => {
            console.log('[ingerations.js] createWorkflow failed', err)
            dispatch({ type: actionTypes.UPDATE_WORKFLOWS, workflows: data })
        })
    }
}

export const updateWorkflow = (workflow, workflows, data, callback) => {
    let updatedWorkflows = {...workflows}
    const workflowId = workflow['workflowId'] 
    updatedWorkflows[workflowId] = workflow
    return dispatch => {
        dispatch({ type: actionTypes.UPDATE_WORKFLOWS, workflows: updatedWorkflows })
        const items = Object.values(data['items']).filter(item => item['workflowId'] === workflowId)
        const itemIDs = items.map(item => item['itemID'])
        const updatedItems = _.omit({...data['items']}, itemIDs)
        let updatedData = {...data}
        updatedData['items'] = updatedItems
        dispatch({type: actionTypes.UPDATE_DATA, data: updatedData})

        api.updateWorkflow(workflowId, {updates: {...workflow}})
        .then(res => {
            console.log('[integrations.js] updateWorkflow completed')
            typeof callback === 'function' && callback()            
        })
        .catch(err => {
            console.log('[integrations.js] updateWorkflow failed', err)
            dispatch({ type: actionTypes.UPDATE_WORKFLOWS, workflows: data })
        })
    }
}

export const deleteWorkflow = (workflow, workflows, data, deleteItems=false, callback) => {
    const debug = true
    let updatedWorkflows = {...workflows}
    const workflowId  = workflow['workflowId'] || workflow['_id']
    delete updatedWorkflows[workflowId]

    return dispatch => {
        dispatch({ type: actionTypes.UPDATE_WORKFLOWS, workflows: updatedWorkflows })
        api.deleteWorkflow(workflowId)
        .then(res => {
            debug && console.log('[deleteWorkflow] Completed')
            typeof callback === 'function' && callback()

            if(deleteItems){
                api.deleteItems({ filters: {
                    workflowId: workflowId
                } })
                .then(deleteRes => {
                    const items = Object.values(data['items']).filter(item => item['workflowId'] === workflowId)
                    const itemIDs = items.map(item => item['itemID'])
                    const updatedItems = _.omit({...data['items']}, itemIDs)
                    let updatedData = {...data}
                    updatedData['items'] = updatedItems
                    dispatch({type: actionTypes.UPDATE_DATA, data: updatedData})
                    console.log('[deleteWorkflow] Items deleted', {workflowId, res: deleteRes.data})
                })
                .catch(deleteErr => {
                    console.log('[deleteWorkflow] Item deletion failed')
                })
            }
        })
        .catch(err => {
            debug && console.log('[deleteWorkflow] Failed', err)
        })
    }
}

export const updateSocketData = (payload) => {
    const data = store.getState().db.present.data.toJS()
    const body = {...payload, data}
    const updatedData = socketUpdates(body)
    return {
        type: actionTypes.UPDATE_DATA, data: updatedData
    }

}